export const datadogConfig = {
  applicationId: 'bacb6952-26a8-4b7d-a8a6-b0c6240f3963',
  clientToken: 'pubd446055f957a40d8b170c23d3a9e9584',
  service: 'customer-hub',
  platform: 'instore',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 5,
} as const
